import InvoiceSettings from './InvoiceSettings';

export default InvoiceSettings;
